import Field from "@/includes/fields/Field";

export type CheckboxValue = [string?, boolean?]

export default class CheckboxField extends Field {

    options: Array<CheckboxValue> = []

    constructor(label: string, options: Array<CheckboxValue>) {
        super(label, '');
        this.options = options;
    }

    clear = (): Field => {
        this.setValue([])
        return this;
    };

    isEmpty(): boolean {
        return 0 === this.getValue().size
    }

    getType = (): string => "checkbox";

    setValue(value?: any) {
        let updated;
        if (Array.isArray(value)) {
            updated = value
            this.options = this.options.map(option => {
                const founded = updated.some(up => up === option[0])
                if(founded) {
                    option[1] = true
                }
                return option
            })
        } else {
            updated = this.options
                .map(option => {
                    if (option[0] === value) {
                        option[1] = true;
                    }
                    return option
                })
                .filter(option => option[1])
                .map(option => option[0])
        }
        super.setValue(updated);
    }
}